<template>
<div class="chapter">
<div class="inner_page">
<p class="poem1">                           … Mine eyes did ne’er<br/>
Rest on a lovely object, nor my mind<br/>
Take pleasure in the midst of happy thoughts,<br/>
But either She whom now I have, who now<br/>
Divides with me this loved abode, was there,<br/>
Or not far off. Where’er my footsteps turned,<br/>
Her Voice was like a hidden Bird that sang;<br/>
The thought of her was like a flash of light<br/>
Or an unseen companionship, a breath<br/>
Or fragrance independent of the wind;<br/>
In all my goings, in the new and old<br/>
Of all my meditations, and in this<br/>
Favourite of all, in this the most of all.<br/>
       —<span class="smallcaps">WILLIAM WORDSWORTH</span>, <i>Home at Grasmere</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// poem.vue?39cebb60